var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebviewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9893 5.92002C8.62933 5.92002 5.90933 8.64002 5.90933 12C5.90933 15.3494 8.62933 18.0694 11.9893 18.0694C15.3387 18.0694 18.0693 15.3387 18.0693 11.9894C18.0693 8.62936 15.3387 5.90936 11.9787 5.90936L11.9893 5.92002ZM4.94933 12C4.94933 8.10669 8.096 4.96002 11.9787 4.96002C15.8613 4.95896 19.0187 8.10669 19.0187 11.9894C19.0187 15.872 15.8667 19.0187 11.968 19.0187C8.07467 19.0187 4.928 15.8614 4.928 11.9787L4.94933 12Z",
    fill: "#9DA6AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3893 12.416H5.58933V11.5627H18.3787V12.416H18.3893Z",
    fill: "#9DA6AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5627 18.4V5.6H12.416V18.4H11.5627ZM15.0507 11.9893C15.0507 9.664 14.208 7.37066 12.576 5.856L13.0773 5.30133C14.8907 6.976 15.776 9.48266 15.776 11.968C15.776 14.4427 14.88 16.9493 13.0667 18.6347L12.5547 18.08C14.1867 16.5547 15.0187 14.2613 15.0187 11.9467L15.0507 11.9893ZM8.24533 11.9893C8.24533 9.504 9.09867 6.99733 10.8587 5.312L11.3707 5.84533C9.78133 7.36 8.97067 9.65333 8.97067 11.968C8.97067 14.2827 9.77067 16.576 11.36 18.0907L10.8373 18.624C9.07733 16.9387 8.21333 14.432 8.21333 11.9467L8.24533 11.9893Z",
    fill: "#9DA6AF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9893 8.21338C14.2933 8.21338 16.6507 8.64005 18.2507 9.52538C18.4213 9.62138 18.4853 9.84538 18.3893 10.0267C18.2827 10.1974 18.0587 10.2614 17.8773 10.1654C16.4373 9.35472 14.2187 8.93872 11.9787 8.93872C9.728 8.93872 7.52 9.35472 6.08 10.1547C5.89866 10.2507 5.664 10.1867 5.568 10.0054C5.46133 9.82405 5.52533 9.58938 5.70666 9.49338C7.296 8.59738 9.65333 8.17072 11.968 8.17072L11.9893 8.21338ZM11.9893 15.5627C14.2933 15.5627 16.6507 15.1254 18.2507 14.24C18.4213 14.1334 18.4853 13.9094 18.3893 13.728C18.2827 13.5467 18.0587 13.4827 17.8773 13.5787C16.4373 14.3787 14.2187 14.7947 11.9787 14.7947C9.728 14.7947 7.52 14.368 6.08 13.568C5.89866 13.4614 5.664 13.5254 5.568 13.7067C5.46133 13.8774 5.52533 14.112 5.70666 14.208C7.296 15.0934 9.65333 15.52 11.968 15.52L11.9893 15.5627Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebviewIcon);
export default __webpack_public_path__ + "static/media/webview-icon.ad306ff89c8de13964be1339294dc6a2.svg";
export { ForwardRef as ReactComponent };